<template>
  <b-card>
    <div slot="header">
      <b-row>
        <b-col class="col-12 col-md-9">
          <strong class="d-flex align-items-center h-100" v-if="title">
            <span class="pr-1">{{ title }} </span>
            <b
              class="badge badge-pill badge-primary fontSize-15"
              v-if="showTotals && totalRows"
            >
              {{ totalRows }}</b
            >
          </strong>
          <template>
            <slot name="title-bar"></slot>
          </template>
        </b-col>
        <b-col class="col-12 col-md-3">
          <div class="float-right">
            <BaseButtons
              :url="url"
              :resourceKey="resourceKey"
              :filterHeaders="filterHeaders"
              :permissions="permissions"
              :extraButtons="extraButtons"
              :hasExportExcel="exportable"
              :hasUploadExcel="hasUploadExcel"
              :defaultViewCount="viewCount"
              :uploadExcelTooltip="uploadExcelTooltip"
              @handleUploadExcel="handleUploadExcel"
              :hasHiddenFields="false"
              :hasRefresh="refreshButton"
              @handleRefresh="refreshList"
              :paramsData="paramsData"
              :hasFilterCache="
                !!(hasFilter && filterCatch && Object.values(paramsData).length)
              "
              :hasFilter="!!(hasFilter && filterHeaders.length)"
              :hasSelectPerPage="hasSelectPerPage"
              :hasAdd="hasAdd"
              @handleAdd="handleAdd"
              @handleSelectPerPage="changeViewCount"
              @getParamsPage="getParamsPage"
              @fetchData="fetchData"
            >
              <template slot="buttons">
                <slot name="headerButtons" />
              </template>
            </BaseButtons>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-row>
      <b-col :class="classData">
        <LoadingSpinner :loading="loadingItem || firstLoad" />
        <h5
          class="text-center"
          v-if="!loadingItem && !firstLoad && !items.length"
        >
          {{ emptyText || $lang.noData }}
        </h5>
        <b-alert
          :variant="colorAlert"
          :show="showAlert && !loadingItem && !firstLoad"
          dismissible
        >
          <div v-html="titleAlert" />
        </b-alert>
        <div class="table-responsive">
          <table
            class="table border"
            v-show="!loadingItem && !firstLoad && items.length"
          >
            <thead>
              <tr class="grey lighten-1">
                <th v-if="showCheckbox" class="text-center"></th>
                <th v-if="hasMoving">{{ hasMoving ? $lang.order : "" }}</th>
                <th
                  v-for="(filde, index) in fildes"
                  :key="index"
                  class="text-center"
                >
                  {{ filde }}
                </th>
                <th v-if="hasMoving" class="text-center">{{ $lang.moving }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, itemKey) in items"
                :key="itemKey"
                class="sortableRow text-center"
              >
                <td v-if="hasMoving">{{ itemKey + 1 }}</td>
                <td v-if="showCheckbox">
                  <b-form-checkbox
                    aria-describedby="flavours"
                    aria-controls="flavours"
                    v-model="item.selected"
                    size="xl"
                    @change="rowClicked(item, $event)"
                  ></b-form-checkbox>
                </td>
                <td v-for="(filde, index) in keyfildes" :key="index">
                  <div v-if="filde === 'operation'">
                    <div class="d-block d-md-none">
                      <b-dropdown variant="primary" left class="mr-1">
                        <template slot="button-content">
                          <i class="fa fa-bars"></i>
                        </template>

                        <b-dropdown-item
                          v-for="(button, index) in availableButtons(item)"
                          :key="index"
                          @click="button.click(item)"
                        >
                          <span
                            v-if="button && typeof button.iconFont === 'object'"
                          >
                            <mdicon
                              :name="pathOr('', ['iconFont', 'name'], button)"
                              :size="pathOr('24', ['iconFont', 'size'], button)"
                              :class="pathOr('', ['iconFont', 'class'], button)"
                            />
                            <small
                              class="font-weight-bold"
                              v-text="button.text"
                            />
                          </span>
                          <span
                            v-if="button && typeof button.iconFont === 'string'"
                          >
                            <i :class="button.iconFont" />
                            <small
                              class="font-weight-bold"
                              v-text="button.text"
                            />
                          </span>
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>

                    <div class="d-none d-md-block">
                      <div
                        class="d-flex align-items-center justify-content-center"
                      >
                        <div
                          class="dynamicButtonGenerated"
                          v-for="(button, index) in availableButtons(item)"
                          :key="index"
                        >
                          <div
                            @click="
                              button.hasConfirm
                                ? showButtonConfirm(button, item)
                                : button.click(item)
                            "
                            v-if="button"
                            class="list-unstyled cursor-pointer mx-2"
                            v-b-tooltip.hover.bottom
                            :title="button.tooltip || button.text"
                          >
                            <mdicon
                              v-if="typeof button.iconFont === 'object'"
                              :name="pathOr('', ['iconFont', 'name'], button)"
                              :size="pathOr('24', ['iconFont', 'size'], button)"
                              :class="pathOr('', ['iconFont', 'class'], button)"
                            />
                            <i v-else :class="button.iconFont" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="filde === 'make_report_enable'">
                    <b-overlay
                      :show="makeReportLoading === item.id"
                      rounded
                      opacity="0.6"
                      spinner-small
                      class="d-inline-block"
                    >
                      <b-button
                        :variant="item.make_report ? 'danger' : 'success'"
                        size="sm"
                        @click="enableMakeReport(item)"
                      >
                        {{ item.make_report ? "غیرفعال کردن" : "فعال کردن" }}
                      </b-button>
                    </b-overlay>
                  </div>
                  <div v-if="filde === 'caption_by_id'">
                    {{ pathOr("", ["id"], item) }}-
                    {{ pathOr("", ["caption"], item) }}
                  </div>
                  <div v-if="filde === 'indicator_click'">
                    <a
                      :href="goToEditExercise(item)"
                      target="_blank"
                      v-text="pathOr(null, ['caption'], item)"
                    />
                  </div>
                  <div v-if="filde === 'public_exam_pack_name'">
                    <span
                      v-if="
                        pathOr(
                          false,
                          ['exam_pack', 'correction_method_algorithm_id'],
                          item
                        ) && checkFrontPageName(item)
                      "
                      class="cursor_pointer text-primary"
                      @click="generateReportRoute(item)"
                    >
                      <span
                        v-text="
                          `${pathOr(null, ['exam_pack', 'id'], item)}- ${pathOr(
                            '',
                            ['exam_pack', 'caption'],
                            item
                          )}`
                        "
                        class="cursor_pointer text-primary"
                      />
                    </span>
                    <span
                      v-else
                      @click="generateReportRoute(item)"
                      v-text="
                        `${pathOr(null, ['exam_pack', 'id'], item)}- ${pathOr(
                          '',
                          ['exam_pack', 'caption'],
                          item
                        )}`
                      "
                      class="cursor_pointer text-primary"
                    />
                  </div>
                  <div v-if="filde === 'completer'">
                    <a
                      :href="goToParvandeh(item)"
                      target="_blank"
                      v-text="pathOr(null, ['manager', 'full_name'], item)"
                    />
                  </div>
                  <div v-if="filde === 'evidence_count'">
                    <b-button @click="goToEditEvidence(item)">
                      {{ pathOr("", ["evidence_count"], item) }}
                    </b-button>
                  </div>
                  <div v-if="filde === 'exam_pack_name'">
                    <a
                      :href="goToExamPack(item)"
                      target="_blank"
                      v-text="pathOr('', [filde], item)"
                    />
                  </div>
                  <div
                    v-if="
                      !includes(filde, [
                        'exam_pack_name',
                        'evidence_count',
                        'completer',
                      ])
                    "
                  >
                    <div v-if="typeof item[filde.split('.')[0]] === 'object'">
                      <div v-if="checkItem(item, filde, 'value')">
                        <i
                          class="fa fa-plus text-success"
                          v-if="checkItem(item, filde, 'value').id == '1'"
                        ></i>
                        <i v-else class="fa fa-minus text-danger"></i>
                      </div>
                      <div v-if="!checkItem(item, filde, 'value')">
                        <div v-if="checkItem(item, filde, 'object') == `مثبت`">
                          <i class="fa fa-plus text-success"></i>
                        </div>
                        <div v-if="checkItem(item, filde, 'object') == `منفی`">
                          <i class="fa fa-minus text-danger"></i>
                        </div>
                        <div
                          v-if="
                            checkItem(item, filde, 'object') !== `مثبت` &&
                            checkItem(item, filde, 'object') !== `منفی`
                          "
                        >
                          {{ checkItem(item, filde, "object") }}
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div
                        v-if="filde === 'share_competency_exercise'"
                        class="text-success"
                      >
                        <mdicon
                          v-if="item[filde.split('.')[0]]"
                          name="check-circle"
                          size="20"
                        />
                      </div>
                      <span v-else v-html="item[filde.split('.')[0]]"></span>
                    </div>
                  </div>
                </td>
                <td v-if="hasMoving" class="sortHandle handle">
                  <i class="fas fa-arrows-alt fa-lg handle"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-col>
    </b-row>
    <PaganationSearch
      v-if="!loadingItem && items.length"
      class="mt-1"
      :allowPaginate="allowPaginate"
      :total="totalRows"
      :total_pages="totalPages"
      :perPage="pathOr(viewCount, ['per_page'], paramsPage)"
      v-model="page"
      @input="paging"
    />
    <b-modal
      :title="$lang.delete"
      header-bg-variant="danger"
      v-model="deleteModal"
      :ok-title="$lang.delete"
      ok-variant="danger"
      :cancel-title="$lang.cancel"
      cancel-variant="success"
      @cancel="!deleteModal"
      @ok="removing"
      :size="removeModalSize"
    >
      <table
        class="table border table-responsive"
        v-show="!loadingItem && items.length > 0"
      >
        <thead>
          <tr class="grey lighten-1">
            <th v-if="hasMoving">{{ hasMoving ? $lang.order : "" }}</th>
            <th
              v-for="(filde, index) in fildes"
              :key="index"
              class="text-center"
            >
              {{ filde }}
            </th>
            <th v-if="hasMoving" class="text-center">{{ $lang.moving }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, confItemKey) in confirmRemoveItem"
            :key="confItemKey"
            class="sortableRow text-center"
          >
            <td v-if="hasMoving">{{ orderNumber(item) }}</td>
            <td v-for="(filde, index) in keyfildes" :key="index">
              <div
                v-if="
                  typeof item[filde.split('.')[0]] == `object` &&
                  filde.includes('.')
                "
              >
                <div v-if="checkItem(item, filde, 'value')">
                  <i
                    class="fa fa-plus text-success"
                    v-if="checkItem(item, value, 'value').id === '1'"
                  />
                  <i v-else class="fa fa-minus text-danger" />
                </div>
                <div v-if="!checkItem(item, filde, 'value')">
                  {{ checkItem(item, filde, "object") }}
                </div>
              </div>
              <div v-else>
                <span v-html="item[filde.split('.')[0]]" />
              </div>
            </td>
            <td v-if="hasMoving" class="sortHandle handle">
              <i class="fas fa-arrows-alt fa-lg handle" />
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </b-card>
</template>
<script>
import Sortable from "sortablejs";
import PaganationSearch from "@/components/base/paganationSearch";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import BaseButtons from "@/components/global/BaseButtons";
import filterMethods from "@/mixin/filterMethods.js";
import { pathOr, includes } from "ramda";
import {
  goToRoute,
  isAdmin,
  checkFrontPageName,
  generateApiUrl,
} from "@/shared/utils";

export default {
  extends: filterMethods,
  components: {
    PaganationSearch,
    LoadingSpinner,
    BaseButtons,
  },
  props: {
    url: {
      type: String,
      default: "",
    },
    keyLang: {
      type: String,
      default: "",
    },
    order_url: {
      type: String,
      default: "",
    },
    keyGroup: {
      type: String,
      default: "",
    },
    valueGroup: {
      type: [String, Number],
      default: "",
    },
    dynamicButtons: {
      type: [Array, Function],
      default: () => [],
    },
    editRoute: {
      type: Boolean,
      default: false,
    },
    hasMoving: {
      type: Boolean,
      default: true,
    },
    removeRoute: {
      type: Boolean,
      default: false,
    },
    showCheckbox: {
      type: Boolean,
      default: false,
    },
    order_by: {
      type: String,
      default: "",
    },
    permissionButtons: {
      type: Array,
      default: () => [],
    },
    showTotals: {
      type: Boolean,
      default: true,
    },
    removeLabel: {
      type: String,
      default: "",
    },
    removeModalSize: {
      type: String,
      default: "lg",
    },
    editLabel: {
      type: String,
      default: "",
    },
    primaryKey: {
      type: String,
      default: "id",
    },
    remove_item: {
      type: Function,
    },
    title: {
      type: String,
      default: "",
    },
    allowPaginate: {
      type: Boolean,
      default: true,
    },
    prePage: {
      type: [String, Number],
      default: "10",
    },
    faLang: {
      type: String,
      default: "",
    },
    itemDeleted: {
      type: Array,
      default: () => [],
    },
    outparams: {
      type: Object,
      default: () => {},
    },
    refreshButton: {
      type: Boolean,
      default: true,
    },
    emptyText: {
      type: String,
      default: "",
    },
    showAlert: {
      type: Boolean,
      default: false,
    },
    colorAlert: {
      type: String,
      default: "info",
    },
    titleAlert: {
      type: String,
      default: "",
    },
    extraButtons: {
      type: Array,
      default: () => [],
    },
    hasFilter: {
      type: Boolean,
      default: true,
    },
    filterCatch: {
      type: Boolean,
      default: false,
    },
    hasAdd: {
      type: Boolean,
      default: false,
    },
    defaultViewCount: {
      type: Number,
      default: 10,
    },
    hasUploadExcel: {
      type: Boolean,
      default: false,
    },
    uploadExcelTooltip: {
      type: String,
      default: "",
    },
    hasSelectPerPage: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    /* eslint-disable no-new */
    new Sortable(document.querySelector("tbody"), {
      draggable: ".sortableRow",
      handle: ".sortHandle",
      onEnd: this.dragReorder,
    });
  },
  data() {
    return {
      totalPages: 0,
      totalRows: 0,
      page: 1,
      items: [],
      fildes: [],
      keyfildes: [],
      availableColumns: [],
      loadingItem: false,
      deleteModal: false,
      confirmRemoveItem: null,
      permissions: [],
      defaultButtons: [
        {
          id: "1",
          name: "edit", // ویرایش
          iconFont: "fa fa-edit text-success fa-lg",
          text: this.$lang.search.edit_tooltip,
          AllowPermissions: ["admin", "edit"],
          click: this.editItem,
        },
        {
          id: "2",
          name: "delete", //حذف
          text: this.$lang.search.remove_tooltip,
          iconFont: "fas fa-times text-danger fa-lg",
          AllowPermissions: ["admin"],
          click: this.removeItem,
        },
        {
          id: "3",
          name: "view", //نمایش
          text: this.$lang.show,
          iconFont: "fa fa-eye fa-lg text-success",
          AllowPermissions: ["view"],
          click: this.modify,
        },
        {
          id: "4",
          name: "insertExerciseDetail", // ویرایش / درج جزء الگوریتم
          text:
            this.$lang.search.edit_tooltip +
            " / " +
            this.$lang.search.insert_exercise_detail_tooltip,
          iconFont: "fa fa-edit fa-lg text-success",
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "5",
          name: "sample_evidence", //  شاهد رفتاری
          iconFont: "fab fa-odnoklassniki  fa-lg  text-info ",
          text: this.$lang.sample_evidence,
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "6",
          name: "selectPreExamPack",
          text: this.$lang.selectPreExamPack,
          iconFont: "fa fa-podcast fa-lg text-primary",
          AllowPermissions: ["admin"],
        },
        {
          id: "7",
          name: "examPackImportAnswers",
          text: this.$lang.import_answers,
          iconFont: {
            name: "cloud-upload",
            size: "24",
            class: "text-primary",
          },
          AllowPermissions: ["admin", "edit"],
        },
      ],
      filter: false,
      classFilter: "",
      classData: "col-12",
      filterHeaders: [],
      itemRemoving: {},
      filterUrl: "",
      filterUrlString: "",
      inputSearch: "",
      paramsData: {},
      paramsPage: {},
      viewCount: this.defaultViewCount,
      resourceKey: null,
      exportable: false,
      otherData: null,
      firstLoad: true,
      makeReportLoading: false,
    };
  },
  created() {
    this.fillTable();
  },
  methods: {
    pathOr,
    includes,
    goToRoute,
    isAdmin,
    checkFrontPageName,
    checkItem(item, filde, part) {
      const fieldSplitted = filde.split(".");
      switch (part) {
        case "object":
          return pathOr("", fieldSplitted, item);
        case "color":
          return pathOr("", [fieldSplitted[0], "color"], item);
        case "value":
          return pathOr("", [fieldSplitted[0], "value"], item);
        default:
          return "";
      }
    },
    rowClicked(item, event) {
      this.$emit("changeCheckbox", item, event, (key, value) => {
        item[key] = value;
      });
    },
    paging(page) {
      this.page = page;
      this.paramsPage["page"] = page;
      this.fetchData();
    },
    editItem(item) {
      if (this.editRoute) {
        this.$emit("edit-item", item);
      } else {
        this.$router.push("edit/" + item[this.primaryKey]);
      }
    },
    removeItem(item) {
      this.confirmRemoveItem = [item];
      this.itemRemoving = item;
      this.deleteModal = true;
    },
    removing() {
      this.loadingItem = true;
      if (this.remove_item != undefined) {
        this.remove_item(this.itemRemoving)
          .then((res) => {
            res && this.fetchData();
          })
          .catch(() => {})
          .finally(() => (this.loadingItem = false));
      } else {
        let id = this.primaryKey ? this.primaryKey : "id";
        return this.$httpService
          .delete(this.url + "/" + this.itemRemoving[this.primaryKey])
          .then((response) => {
            this.$notify.success(response.data.message);
            this.fetchData();
          })
          .catch((err) => {
            this.$notify.error(err.response.data.message);
            this.loadingItem = false;
          });
      }
    },
    availableButton2(item) {
      // create buttons
      let generateButtons = [];
      if (typeof this.dynamicButtons === "object")
        generateButtons = this.dynamicButtons;
      else generateButtons = this.dynamicButtons(item);

      return generateButtons
        .filter((button) => {
          let permission = this.defaultButtons.find(
            (x) => x.name == button.name
          );

          // compare button permission and user permissions
          // debugger
          let ok = Object.values(this.permissions).filter((x) =>
            permission.AllowPermissions.includes(x)
          );
          // compare keys button has and defult button dosent have
          return ok.length;
        })
        .map((but) => {
          let temp = Object.assign({}, but); // clone
          let permission = this.defaultButtons.find((x) => x.name == but.name);
          permission.show = pathOr(true, ["show"], permission);

          if (permission.name == "enable") {
            temp.iconFont =
              item.is_enable == 1
                ? "fa fa-unlock text-warning fa-lg"
                : "fa fa-lock text-warning fa-lg";
            temp.text =
              item.is_enable == 1
                ? this.$lang.search.enabled_tooltip
                : this.$lang.search.disabled_tooltip;
          }

          return {
            ...permission,
            ...temp,
          };
        });
    },
    availableButtons(item) {
      const generateButtons =
        typeof this.dynamicButtons === "object"
          ? this.dynamicButtons
          : this.dynamicButtons(item);

      return generateButtons
        .filter((button) => {
          let defaultButton = this.defaultButtons.find(
            (x) => x.name === button.name
          );
          defaultButton = {
            ...defaultButton,
            ...button,
          };

          // check permissions
          const buttonPermissions = pathOr(
            [],
            ["AllowPermissions"],
            defaultButton
          );
          return isAdmin(buttonPermissions, this.permissionButtons);
        })
        .map((but) => {
          const showIcon = pathOr(true, ["showIcon"], but);
          if (!showIcon) return;
          const temp = { ...but, show: true };
          const permission = this.defaultButtons.find(
            (x) => x.name === but.name
          );
          if (permission.name == "enable") {
            temp.iconFont =
              item.is_enable == 1
                ? "fa fa-unlock text-warning fa-lg"
                : "fa fa-lock text-warning fa-lg";
            temp.text =
              item.is_enable == 1
                ? this.$lang.search.enabled_tooltip
                : this.$lang.search.disabled_tooltip;
          }
          /* guidance: filter buttons just show option is true */
          if (temp.show) {
            return {
              ...permission,
              ...temp,
            };
          }
        });
    },
    dragReorder({ oldIndex, newIndex }) {
      const startOrder = pathOr(null, ["order"], this.items[oldIndex]);
      const endOrder = pathOr(null, ["order"], this.items[newIndex]);
      const movedItem = this.items.splice(oldIndex, 1)[0];
      this.items.splice(newIndex, 0, movedItem);
      this.setOrder(startOrder, endOrder, movedItem);
    },
    async setOrder(start_order, end_order, movedItem) {
      try {
        this.loadingItem = true;
        const payload = {
          start_order,
          end_order,
        };
        if (this.keyGroup) {
          payload["group"] = {
            key: this.keyGroup,
            value: movedItem[this.keyGroup]
              ? movedItem[this.keyGroup]
              : `${this.valueGroup}`,
          };
        }

        const url = this.$config.api_url + this.order_url;
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        await this.fetchData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loadingItem = false;
      }
    },
    orderNumber(item) {
      return this.items.length ? this.items.indexOf(item) + 1 : 1;
    },
    onClick() {
      this.dialog = true;
    },
    async fetchData() {
      this.items = [];
      this.fildes = this.faLang
        ? this.$lang[this.faLang][this.keyLang]
        : this.$lang[this.keyLang];

      try {
        this.loadingItem = true;
        const { per_page, order_by, page, locale_id, ...otherFilter } =
          this.paramsPage;
        const output = { ...otherFilter };
        for (const key in Object.keys(output)) {
          if (Object.hasOwnProperty.call(output, key)) {
            if (Object.hasOwnProperty.call(this.outparams, key)) {
              delete output[key];
            }
          }
        }
        this.paramsData = { ...output };
        const response = await this.$httpService.get(this.url, this.paramsPage);
        const data = pathOr(null, ["data", "data"], response);
        const result = pathOr([], ["result"], data);
        const permissions = pathOr([], ["data", "permissions"], response);
        this.otherData = pathOr([], ["data", "other"], response);
        this.$emit("getOther", this.otherData);
        this.$emit("getPermisson", permissions);
        this.exportable = pathOr(false, ["data", "exportable"], response);
        this.resourceKey = pathOr(null, ["data", "resource"], response);
        this.filterHeaders = pathOr([], ["data", "filters"], response);
        this.permissions = this.permissionButtons.length
          ? this.permissionButtons
          : permissions;

        if (this.itemDeleted.length) {
          this.items = [...this.itemDeleted];
        } else {
          this.items = result.length ? [...result] : [...data];
        }
        this.totalRows = pathOr(null, ["total"], data);
        this.totalPages = pathOr(null, ["total_pages"], data);
        this.availableColumns = Object.keys(this.fildes).map((x) => {
          return {
            label: this.fildes[x],
            key: x,
            sortable: true,
          };
        });
        this.keyfildes = Object.keys(this.fildes);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.firstLoad = false;
        this.loadingItem = false;
        this.$emit("countItems", this.items && this.items.length);
      }
    },
    async refreshList(callback) {
      try {
        await this.fetchData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        callback();
      }
    },
    handleAdd() {
      this.$emit("handleAdd");
    },
    getParamsPage(data) {
      this.paramsPage = data;
    },
    changeViewCount(value) {
      this.viewCount = value;
      this.paramsPage["per_page"] = this.viewCount;
      this.fetchData();
    },
    async fillTable() {
      if (this.filterCatch) {
        const params = await this.getFilterCacheResource();
        if (params) {
          this.page = pathOr(1, ["page"], params);
          for (const key of Object.keys(params)) {
            this.paramsPage[key] = params[key];
          }
        }
      } else {
        this.paramsPage["page"] = 1;
      }
      this.paramsPage["per_page"] = this.viewCount;
      if (this.order_by) {
        this.paramsPage["order_by"] = this.order_by;
      }

      this.paramsPage = {
        ...this.paramsPage,
        ...this.outparams,
        ...this.filterUrl,
      };

      this.fetchData();
    },
    handleUploadExcel() {
      this.$emit("handleUploadExcel");
    },
    goToExamPack(item) {
      const id = pathOr(null, ["id"], item);
      if (id) {
        const routerData = this.$router.resolve({
          name: "edit_exam_pack",
          params: { id },
        });
        return routerData.href;
      }
    },
    goToEditExercise(item) {
      const id = pathOr(null, ["id"], item);
      if (id) {
        const routerData = this.$router.resolve({
          name: "EditIndicator",
          params: { id },
        });
        return routerData.href;
      }
    },
    goToEditEvidence(item) {
      const id = pathOr(null, ["exercise_design_id"], item);
      if (id) {
        const name = "indicator-exercise-evidence";
        const params = { id };
        goToRoute(name, params);
      }
    },
    generateReportRoute(item) {
      const correctionMethodAlgorithmId = pathOr(
        false,
        ["exam_pack", "correction_method_algorithm_id"],
        item
      );
      if (!correctionMethodAlgorithmId)
        return this.$notify.warning("برای این پرسشنامه گزارشی ایجاد نشده است");

      const name = `${pathOr(null, ["front_page_name"], item)}-report`;
      const params = {
        parvandehCode: pathOr(null, ["parvandeh", "code"], this.otherData),
        examPackId: pathOr(null, ["exam_pack", "id"], item), // use in azmoon module
        resourceCode: pathOr(null, ["azmoon_execute", "code"], item), // use in kanoon and azmoon module
      };
      goToRoute(name, params);
    },
    goToParvandeh(item) {
      const parvandeh_number = pathOr(
        null,
        ["manager", "parvandeh_number"],
        item
      );
      const routerData = this.$router.resolve({
        name: "parvandeh_by_number",
        params: { parvandeh_number },
      });
      return routerData.href;
    },
    async enableMakeReport(item) {
      try {
        this.makeReportLoading = pathOr(null, ["id"], item);
        const azmoonExecuteId = pathOr(null, ["azmoon_execute_id"], item);
        const examPackId = pathOr(null, ["id"], item);
        const url = generateApiUrl(
          ["azmoon", "exam_pack_make_report"],
          [azmoonExecuteId, examPackId]
        );
        const makeReport = pathOr(0, ["make_report"], item);
        const payload = { make_report: makeReport ? 0 : 1 };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.fetchData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.makeReportLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.handle {
  cursor: pointer;
}

tbody tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.01);
}

tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.pprint {
  white-space: pre-wrap;
  word-wrap: break-word;
}

.bg-lightgray {
  background-color: #f2f2f2;
}

.position-badge {
  position: absolute !important;
  right: -6px;
  top: -7px !important;
}
</style>
